import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  DestroyList: (param) => { // 注销记录列表
    return GET("/backend/user/xcx/destroyList", param);
  },
  noDestroyList: (param) => {
    return GET("/backend/user/xcx/noDestroyList", param)
  },
  DestroyStatus: (param) => { // 注销状态申请
    return POST("/backend/user/xcx/destroyStatus", param);
  },
  queryDestroy: (param, rsType) => { // 注销列表导出-已认证
    return GETPDF("/backend/user/xcx/queryDestroy", param, rsType);
  },
  NoQueryDestroy: (param, rsType) => { // 注销列表导出-未认证
    return GETPDF("/backend/user/xcx/NoQueryDestroy", param, rsType);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/checkmark.js